import { ConsignmentStatus } from 'themes/types';

import { SYSTEM_COLORS } from '../system-colors';

export const CONSIGNMENT_STATUS: ConsignmentStatus = {
  consignmentStatus: {
    default: {
      primary: SYSTEM_COLORS.neutral_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    AVAILABLE_FOR_STORE: {
      primary: SYSTEM_COLORS.warning_500,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    RESERVED_BY_STORE: {
      primary: SYSTEM_COLORS.warning_300,
      secondary: SYSTEM_COLORS.neutral_700,
    },
    CONFIRMED_BY_STORE: {
      primary: SYSTEM_COLORS.warning_200,
      secondary: SYSTEM_COLORS.neutral_700,
    },
    RELEASE_PAYMENT: {
      primary: SYSTEM_COLORS.warning_200,
      secondary: SYSTEM_COLORS.neutral_700,
    },
    SHIPPED: {
      primary: SYSTEM_COLORS.warning_200,
      secondary: SYSTEM_COLORS.neutral_700,
    },
    READY_FOR_CUSTOMER_PICKUP_IN_STORE: {
      primary: SYSTEM_COLORS.success_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    READY_FOR_PICKUP_BY_DRIVER: {
      primary: SYSTEM_COLORS.success_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    PICKUP_BY_DRIVER: {
      primary: SYSTEM_COLORS.success_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    DELIVERED_BY_DRIVER: {
      primary: SYSTEM_COLORS.success_500,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    DELIVERED: {
      primary: SYSTEM_COLORS.success_500,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    MANUALLY_DELIVERED: {
      primary: SYSTEM_COLORS.success_500,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    CLARIFY_DELIVERY_FAIL: {
      primary: SYSTEM_COLORS.danger_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    COLLECT_FAIL: {
      primary: SYSTEM_COLORS.danger_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    CANCELLED: {
      primary: SYSTEM_COLORS.neutral_500,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    WAIT_FOR_INVOICE: {
      primary: SYSTEM_COLORS.warning_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
  },
};
